<template>
  <div class="upload-wrapper">
    <button :style="{ width, height, borderRadius: radius }" class="upload-btn" type="button" @click="onclick">
      <i v-if="!percent && !url" class="el-icon-plus" />
      <input ref="inputFile" accept="image/*" type="file" @change="onChange" />
      <img v-if="previewUrl || url" :src="previewUrl ? previewUrl : url" alt="" />
      <span v-if="percent > 0" class="percent">{{ percent }}%</span>
    </button>
    <el-button v-if="showDelBtn" class="del-btn" icon="el-icon-delete" plain type="danger" @click="onDel"> </el-button>
    <span v-if="tips" class="tips">{{ tips }}</span>
  </div>
</template>

<script>
import { uploadFile } from "@/plugins/uploadFile";

export default {
  name: "UploadImg",
  mixins: [],
  props: {
    width: {
      type: String,
      default: "80px"
    },
    radius: {
      type: String,
      default: "4px"
    },
    height: {
      type: String,
      default: "80px"
    },
    url: {
      type: String,
      default: ""
    },
    showDelBtn: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: ""
    },
    maxSize: {
      type: Number,
      default: 1024
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "url",
    event: "update"
  },
  components: {},
  data() {
    return {
      // 0=>未上传，1=>上传中
      status: 0,
      percent: 0,
      previewUrl: ""
    };
  },
  computed: {},
  methods: {
    onclick() {
      const { inputFile } = this.$refs;
      inputFile.click();
    },
    onChange(event) {
      let file = event.target.files[0];
      this.percent = 0;
      const progressCb = percent => {
        this.percent = percent;
      };
      uploadFile({
        file,
        progressCb,
        maxSize: this.maxSize
      })
        .then(res => {
          this.percent = 100;
          this.$emit("update", res.url);
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message(err.msg);
          }
        });
    },
    onDel() {
      this.$refs.inputFile.value = "";
      this.$emit("update", "");
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.upload-wrapper {
  display: inline-flex;
  align-items: flex-end;
  overflow: hidden;
  vertical-align: middle;
}

.upload-btn {
  display: inline-block;
  background: @border-basic;
  position: relative;
  border: 1px solid fade(@text-gray, 50%);
  cursor: pointer;
  overflow: hidden;
}

.el-icon-plus {
  font-size: 30px;
  color: @text-gray;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

input[type="file"] {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 10;
  vertical-align: middle;
}

.percent {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 11;
  transform: translate(-50%, -50%);
  text-shadow: 0 0 3px @text-gray;
  color: #fff;
  font-size: 12px;
}

.del-btn {
  font-size: 18px;
  padding: 0 8px;
  height: 32px;
  margin-left: 10px;
}

.tips {
  color: @gray;
  font-size: 12px;
  margin-left: 10px;
}
</style>
